import { createElement } from 'react';
import { App } from 'antd';
import { FkIcon } from './Icons';

/** Тексты тостов (прототип behaviour.md §2.6 + существующие тексты кода). */
export const TOASTS = {
  refresh: 'Данные обновлены',
  recalc: 'Аудитория пересчитана',
  draftSaved: 'Черновик сохранён. Отправка не запущена.',
  pausedSaved: 'Изменения сохранены. Кампания остаётся на паузе.',
  copy: 'Копия открыта в редакторе — сохраните её, чтобы она появилась в черновиках',
  pause: 'Кампания на паузе — новые сообщения не уходят',
  resume: 'Кампания снова работает',
  cancel: 'Кампания отменена. Отправленные сообщения остаются в отчёте',
  delete: 'Кампания удалена из списка',
  maxSteps: 'В сценарии не больше десяти сообщений',
  fillRequired: 'Сначала заполните обязательные поля',
  tourDone: 'Обучение завершено. Его можно пройти снова из меню',
  practiceDone: 'Обучение пройдено. Черновик готов; запуск подтвердите отдельно.',
  launched: 'Кампания запущена. Статусы отправки доступны в списке кампаний.',
  invoiceCreated: (sum: string) => `Счёт на ${sum} сформирован и отправлен на почту`,
  pdfDownloaded: (n: string) => `Счёт ${n} скачан`,
  templateSaved: 'Шаблон сохранён. Теперь его можно выбрать в кампании.',
  promoCreated: 'Серия промокодов создана',
  promoReplenished: 'Серия пополнена',
} as const;

const DURATION = 2.6;

/** Ключ по тексту: повторный тост с тем же текстом заменяет прежний, а не ложится сверху. */
const toastKey = (kind: string, text: string) => `fk-${kind}-${text}`;

/** Тост прототипа: тёмная плашка с галочкой (App.useApp().message, 2,6 с). Только внутри <AntdApp>. */
export function useToast(): { show: (text: string) => void; error: (text: string) => void } {
  const { message } = App.useApp();
  return {
    show: (text) =>
      void message.open({
        key: toastKey('ok', text),
        content: text,
        duration: DURATION,
        icon: createElement(FkIcon, { name: 'check', size: 14 }),
      }),
    error: (text) =>
      void message.open({
        key: toastKey('err', text),
        content: text,
        duration: DURATION,
        icon: createElement(FkIcon, { name: 'alert', size: 14 }),
      }),
  };
}
